import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { LocalService } from 'src/app/services/local.service'
import { PainelService } from 'src/app/services/painel.service'
import { ServerUrlService } from 'src/app/services/server-url.service'
import { PainelType } from 'src/app/settings/interfaces/painel'
import { PainelLocalType } from 'src/app/settings/interfaces/painelLocal'

@Component({
  selector: 'app-add-painel',
  templateUrl: './add-painel.component.html',
  styleUrls: ['./add-painel.component.scss'],
})
export class AddPainelComponent implements OnInit {
  public tabGroupIndex: number = 0
  public columns = [
    {
      columnDef: 'nome',
      header: 'Nome',
      cell: (element: PainelType) => `${element.nome}`,
    },
    {
      columnDef: 'datacriacao',
      header: 'Data criação',
      cell: (element: PainelType) => `${element.datacriacao}`,
    },
    {
      columnDef: 'url',
      header: 'URL',
      cell: (element: PainelType) => `${element.url}`,
    },
    {
      columnDef: 'status',
      header: 'Status',
      cell: (element: PainelType) => `${this.formatBotao(element.status!)}`,
    },
    {
      columnDef: 'edit',
    },
  ]
  public columnsLocal = [
    {
      columnDef: 'localid',
      header: 'Local',
      cell: (element: PainelLocalType) => `${element.localid}`,
    },
    {
      columnDef: 'tipo',
      header: 'Tipo',
      cell: (element: PainelLocalType) => `${element.tipo}`,
    },
    {
      columnDef: 'edit',
    },
  ]
  public mode: string = 'all'
  public paineis: Array<PainelType> = []
  public paineisLocaisTemp: Array<PainelLocalType> = []
  public showSpinner: boolean = false
  public painel: PainelType = {}
  public formPainelLocal!: FormGroup
  public painelLocalMode = 'all'
  public painelLocal: PainelLocalType = {}
  public paineisLocais: Array<PainelLocalType> = []
  public formPainel!: FormGroup
  public empresas: Array<any> = []
  public agendas: Array<any> = []
  public locais: any
  public displayedColumns = this.columns.map((c) => c.columnDef)
  public displayedColumnsLocal = this.columnsLocal.map((c) => c.columnDef)

  constructor(
    private painelService: PainelService,
    private serverUrl: ServerUrlService,
    private formBuilder: FormBuilder,
    private localService: LocalService
  ) {}

  submitPainelLocalForm() {
    this.showSpinner = true
    if (this.formPainelLocal.valid) {
      if (this.formPainelLocal.value.paineistvid) {
        this.painelService.updatePainelLocal(this.formPainelLocal.value)
      } else if (this.painel && this.painel.id) {
        this.formPainelLocal.controls['paineistvid'].setValue(this.painel.id)
        this.painelService.insertPainelLocal(this.formPainelLocal.value)
      } else {
        if (this.formPainelLocal.value.tipo === 'empresa') {
          this.formPainelLocal.value.local = this.findEmpresa(this.formPainelLocal.value).nome
        } else if (this.formPainelLocal.value.tipo === 'agenda') {
          this.formPainelLocal.value.local = this.findAgenda(this.formPainelLocal.value).nome
        } else {
          this.formPainelLocal.value.local = this.findLocal(this.formPainelLocal.value).nome
        }
        this.paineisLocaisTemp.push(this.formPainelLocal.value)
      }
      setTimeout(() => {
        this.painelLocalMode = 'all'
        this.painelLocal = {}
        if (this.painel && this.painel.id) {
          this.paineisLocais = []
          this.loadPainelLocais(this.formPainelLocal.value.paineistvid)
        } else {
          this.paineisLocais = []
          this.paineisLocais = this.paineisLocaisTemp
        }
      }, 1000)
    } else {
      alert('Dados obrigatórios não preenchidos.')
    }
    setTimeout(() => {
      this.showSpinner = false
    }, 1000)
  }

  submitForm() {
    if (this.formPainel.valid) {
      this.showSpinner = true
      if (this.formPainel.value.id) {
        this.painelService.updatePainel(this.formPainel.value)
      } else {
        if (this.paineisLocaisTemp.length > 0) {
          this.formPainel.controls['locais'].setValue(this.paineisLocaisTemp)
        }
        this.painelService.insertPainel(this.formPainel.value)
      }
      setTimeout(() => {
        this.paineisLocaisTemp = []
        this.cleanForm()
        this.paineis = []
        this.paineisLocais = []
        this.loadPaineis()
        // alert(this.getUrl(this.painelService.lastInserted))
        // location.reload()
        this.showSpinner = false
      }, 1500)
    } else {
      this.tabGroupIndex = 0
      alert('Dados obrigatórios não preenchidos.')
    }
  }

  formatBotao(element: boolean): String {
    if (element === false) {
      return 'Não'
    } else {
      return 'Sim'
    }
  }

  formatStatus(element: boolean): String {
    if (element === false) {
      return 'Inativo'
    } else {
      return 'Ativo'
    }
  }

  getUrl(id: any) {
    return `/${this.serverUrl.getName()}/painel/${id}`
  }

  loadPaineis() {
    this.painelService.getPaineis().subscribe((resp) => {
      this.paineis = resp
      this.paineis.forEach((element) => {
        element.datacriacao = new Date(element.datacriacao).toISOString().split('T')[0]
        element.url = this.getUrl(element.id)
      })
    })
  }

  deletePainel(i: number) {
    if (this.painel) {
      this.showSpinner = true
      this.painelService.deletePainel(i)
      setTimeout(() => {
        this.cleanForm()
        this.loadPaineis()
        this.showSpinner = false
      }, 1000)
    }
  }

  cleanForm() {
    this.paineisLocaisTemp = []
    this.painel = {}
    this.setForm()
    this.mode = 'all'
  }

  cleanPainelLocalForm() {
    this.painelLocal = {}
    this.painelLocalMode = 'all'
  }

  newPainelLocalForm(i?: number) {
    this.createPainelLocalForm(i)
    this.painelLocalMode = 'form'
  }

  createPainelLocalForm(i: number | undefined) {
    if (i !== undefined) {
      this.painelLocal = this.paineisLocais[i]
    }
    this.formPainelLocal = this.formBuilder.group({
      id: [this.painelLocal.id ? this.painelLocal.id : undefined],
      localid: [this.painelLocal.localid ? this.painelLocal.localid : '', Validators.required],
      paineistvid: [this.painelLocal.paineistvid ? this.painelLocal.paineistvid : null],
      tipo: [this.painelLocal.tipo ? this.painel.tipo : '', Validators.required],
      local: [this.painelLocal.tipo ? this.painelLocal.tipo : ''],
      messagecheckin: [this.painelLocal.messagecheckin ? this.painelLocal.messagecheckin : '']
    })
  }

  findEmpresa(element: PainelLocalType) {
    return this.empresas.find((e: any) => e.id === element.localid)
  }

  findAgenda(element: PainelLocalType) {
    const localid = element.localid
    if (localid == null) {
      return undefined
    }

    if (typeof localid === 'number') {
      return this.agendas.find((e) => e.id === localid)
    }

    return this.agendas.find((e) => e.id === localid.id && e.tipo === localid.tipo)
  }

  getEmpresas() {
    this.painelService.getEmpresas().subscribe((resp) => {
      this.empresas = resp
    })
  }

  getAgendas() {
    this.painelService.getAgendas().subscribe((resp) => {
      this.agendas = resp
    })
  }

  getLocais() {
    this.localService.getLocais().subscribe((resp) => {
      this.locais = resp
    })
  }

  findLocal(element: PainelLocalType) {
    return this.locais.find((e: any) => e.id === element.localid)
  }

  loadPainelLocais(id: number) {
    this.painelService.getPainelLocais(id).subscribe((resp) => {
      this.paineisLocais = resp.map((local: any) => {
        if (local.tipo === 'agenda') {
          local.localid = {
            id: local.localid,
            tipo: local.agendatipo,
          }
        }
        return local
      })
      this.paineisLocais.forEach((element) => {
        if (element.tipo === 'empresa') {
          element.local = this.findEmpresa(element).nome
        } else if (element.tipo === 'agenda') {
          element.local = this.findAgenda(element).nome
        } else {
          element.local = this.findLocal(element).nome
        }
      })
    })
  }

  deletePainelLocal(i: number) {
    this.paineisLocais = this.paineisLocais?.filter(p => p.tipo !== 'agenda')
    this.showSpinner = true
    if (this.formPainel.value.id !== null) {
      let id = this.paineisLocais[i].id
      this.painelService.deletePainelLocal(id!)
      setTimeout(() => {
        this.paineisLocais = []
        this.loadPainelLocais(this.painel.id!)
      }, 1000)
    } else {
      this.paineisLocais = []
      this.paineisLocaisTemp.splice(i, 1)
      setTimeout(() => {
        this.paineisLocais = this.paineisLocaisTemp
      }, 100)
    }
    setTimeout(() => {
      this.showSpinner = false
    }, 1000)
  }

  deletePainelLocalAgenda(i: number) {
    this.paineisLocais = this.paineisLocais?.filter(p => p.tipo === 'agenda')
    this.showSpinner = true
    if (this.formPainel.value.id !== null) {
      let id = this.paineisLocais[i].id
      this.painelService.deletePainelLocal(id!)
      setTimeout(() => {
        this.paineisLocais = []
        this.loadPainelLocais(this.painel.id!)
      }, 1000)
    } else {
      this.paineisLocais = []
      this.paineisLocaisTemp.splice(i, 1)
      setTimeout(() => {
        this.paineisLocais = this.paineisLocaisTemp
      }, 100)
    }
    setTimeout(() => {
      this.showSpinner = false
    }, 1000)
  }

  setForm() {
    this.formPainel.controls['id'].setValue(this.painel.id)
    this.formPainel.controls['nome'].setValue(this.painel.nome)
    this.formPainel.controls['datacriacao'].setValue(this.painel.datacriacao)
    if (this.painel.status) {
      this.formPainel.controls['status'].setValue(this.painel.status!.toString())
    }
  }

  createForm() {
    this.formPainel = this.formBuilder.group({
      id: [this.painel.id ? this.painel.id : undefined],
      datacriacao: [this.painel.datacriacao ? this.painel.datacriacao : ''],
      nome: [this.painel.nome ? this.painel.nome : null, Validators.required],
      status: [this.painel.status ? this.painel.status : null, Validators.required],
      locais: [],
    })
  }

  setPainel(i: number) {
    this.painel = this.paineis[i]
    this.painelService.getPainelLocais(this.painel.id!).subscribe((resp) => {
      console.log(resp)

      this.painel.locais = []
      resp.forEach((element: { localid: number }) => {
        this.painel.locais?.push(element.localid)
      })
      this.setForm()
    })
    this.loadPainelLocais(this.painel.id!)
  }

  newForm(i?: number) {
    this.paineisLocaisTemp = []
    this.createForm()
    if (i !== undefined && i !== null) {
      this.setPainel(i)
    }
    this.mode = 'form'
  }

  get paineisLocaisAgenda(): PainelLocalType[] {
    return this.paineisLocais?.filter(p => p.tipo === 'agenda') || [];
  }  

  get paineisLocalEmpresa(): PainelLocalType[] {
    return this.paineisLocais?.filter(p => p.tipo !== 'agenda') || [];
  }

  setTipoAgendaAndCreateForm() {
    this.newPainelLocalForm()
    this.formPainelLocal.get('tipo')?.setValue('agenda')
  }

  ngOnInit(): void {
    this.loadPaineis()
    this.getLocais()
    this.getEmpresas()
    this.getAgendas()
  }
}
